import { render, staticRenderFns } from "./SelectRole.vue?vue&type=template&id=9a8a3104"
import script from "./SelectRole.vue?vue&type=script&lang=js"
export * from "./SelectRole.vue?vue&type=script&lang=js"
import style0 from "./SelectRole.vue?vue&type=style&index=0&id=9a8a3104&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports